<template>
  <div class="owc-business-unit-switch">
    <ValidationBoxWrapper v-if="isEditMode">
      <slot slot="validation-box" name="validation-box" />
    </ValidationBoxWrapper>
    <div class="wb-grid-container">
      <div class="wb-grid-row">
        <div class="wb-grid-col-mq1-12">
          <h4 class="owc-business-unit-switch__title wb-type-heading-xs">{{ componentData.title }}</h4>
        </div>
      </div>
    </div>
    <wb-slider off-grid grid-gutter show-dot-navigation show-arrow-navigation theme="dark">
      <div
        class="wb-slider__item tile wb-grid-col-mq1-5 wb-grid-col-mq3-3 wb-grid-col-mq4-2"
        v-for="(unit, index) in componentData.units"
        :key="index"
      >
        <BusinessUnit
          :url="unit.link.url"
          :label="unit.label"
          :iconId="unit.iconId"
          :target="unit.link.target"
        >
        </BusinessUnit>
      </div>
    </wb-slider>
  </div>
</template>

<script lang="ts">
/**
 * `BusinessUnitSwitch` - The BU switch "Business unit switch" is a row of cards leading to the external pages of other Mercedes-Benz business units.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import BusinessUnit from './BusinessUnit.vue';
import { BusinessUnitSwitchComponent } from './BusinessUnitSwitch';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
export default (ComponentInitializeDispatcher as BusinessUnitSwitchComponent).extend({
  name: 'owc-business-unit-switch',
  components: {
    BusinessUnit,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
});
</script>

<style lang="scss">
@import '@owc-styles/utils/grid';

$_special-breakpoint: 500px;
$businessUnitSwitchModuleName: 'owc-business-unit-switch';

.#{$businessUnitSwitchModuleName} {
  padding: var(--wb-spacing-l) 0;

  color: var(--wb-white);

  background-color: var(--wb-black);

  &__title {
    margin-bottom: var(--wb-spacing-s);
  }
  .wb-slider__item {
    // handle case where cards would become to big
    // set it to fit 3 cards per viewport

    @media screen and (min-width: $_special-breakpoint) and (max-width: get-breakpoint-value(mq3)) {
      @include grid-columns-width(3); // mixin from workbench
    }
  }
}
</style>
